export default __webpack_public_path__ + "static/media/level_2.52ac7959.jpg";